// @TODO, pull from config
export const DAYS_TO_REPLY = 14;
